export const Navigations = {
    TIME_TRIVIA: {
      label: "Time Trivia",
      routerLink: "/time-trivia",
      path: 'time-trivia'
    },
    PREDICT_WIN: {
      label: "Predict & Win",
      routerLink: "/pw",
      path: 'pw'
    },
}